<template>
  <i :class="className"></i>
</template>

<script>
export default {
  name: 'icon',
  props: {
    type: String,
    big: [String, Boolean]
  },
  computed: {
    className () {
      return [
        `weui-icon-${this.type}`,
        this.big ? 'weui-icon_msg' : ''
      ]
    }
  }
}
</script>

<style>
.icon_big:before {
  font-size: 104px;
}
.icon_small:before {
  font-size: 12px;
}
</style>
